// Cost JDE still carries on the wrong phase code while a job cost transfer to
// the right one is pending. Fusion reads those rows on the code they are
// moving to, so the budget and its actuals meet before the transfer posts.
// Every row on the old code moves, the transfer's own reversal included, so
// the figures stay right once JDE posts it; take the entry out after that.
//   job -> { from code: to code }
export const PENDING_COST_MOVES = {
    '54026071': {
        // The 10/18 week's UG 3" conduit labor ($21,777.54, 253.5 h) went on
        // the master chart's 120616; the job budgets it on 220616 (Seth 10/23:
        // "we have a job cost to transfer it to 220616").
        '120616': '220616',
        // The same week's Handling / Install CS ($12,092.15, 259 h) has no
        // budget; it is pipe handling (Seth 10/23: "it should move to pipe
        // handling 160321").
        '160334': '160321',
    },
};

const moveOf = (r, job) => {
    const moves = PENDING_COST_MOVES[String(r?.Job_Number ?? job ?? '').trim()];
    return moves ? moves[String(r?.Phase_Code ?? '').trim()] : undefined;
};

// Cost history rows with the pending moves applied. A row keeps every other
// field (Form_Job_Cost_History_Key included, so billed state and invoice links
// follow it) and notes the code it came from. `job` is for reads whose rows
// carry no Job_Number (the condensed read). Unchanged rows come back as the
// same array.
export function applyCostMoves(rows, job) {
    if (!Array.isArray(rows) || !rows.some((r) => moveOf(r, job))) return rows;
    return rows.map((r) => {
        const to = moveOf(r, job);
        return to ? { ...r, Phase_Code: to, Moved_From_Phase_Code: r.Phase_Code } : r;
    });
}

// An API response ({ data: rows }) with the moves applied.
export const withCostMoves = (res, job) =>
    (res && Array.isArray(res.data) ? { ...res, data: applyCostMoves(res.data, job) } : res);
